module.exports = __webpack_public_path__ + "static/media/banner-affiliate.ed0793eb.png";